import React from "react"
import { Phone, ArrowRight } from "lucide-react"
import logo from '../assets/mainImg/mainBrown.png'

const Header = ({ setBookForm }) => {
  return (
    <header className="
      sticky top-0 z-10
      bg-gradient-to-br from-slate-950 via-blue-950 to-purple-950
      border-b border-white/10
      backdrop-blur-lg">

      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 sm:py-4">
        <div className="flex items-center justify-between">

          {/* Brand */}
          <div className="group flex items-center space-x-2 sm:space-x-4 cursor-pointer">

            {/* Logo */}
            <div className="relative">
              <div className="
                w-14 h-14 sm:w-16 sm:h-16 md:w-20 md:h-20
                flex items-center justify-center rounded-xl
                transition-all duration-500
                group-hover:rotate-6 group-hover:scale-110 bg-white">
                <img 
                  src={logo} 
                  alt="SSK Travels" 
                  className="w-full h-full rounded-xl scale-140"
                />
              </div>

              <div className="
                absolute inset-0 rounded-xl
                ring-1 sm:ring-2 ring-cyan-400/30
                group-hover:ring-emerald-400/50
                transition-all duration-500 group-hover:scale-110">
              </div>
            </div>

            {/* Text */}
            <div className="transition-all duration-500 group-hover:translate-x-1">
              <h1 className="
                text-lg sm:text-xl font-extrabold tracking-wide
                bg-gradient-to-r from-pink-400 via-purple-400 to-indigo-400
                bg-clip-text text-transparent
                whitespace-nowrap">
                SSK TRAVELS
              </h1>
              <p className="
                text-[10px] xs:text-[11px] uppercase tracking-[0.2em] sm:tracking-[0.25em]
                text-cyan-300 opacity-80
                group-hover:opacity-100 transition
                whitespace-nowrap">
                Premium Travel Services
              </p>
            </div>
          </div>

          {/* Actions */}
          <div className="flex items-center space-x-2 sm:space-x-4">

            {/* Phone - Mobile Icon Only */}
            <a
              href="tel:9551776782"
              className="
                sm:hidden flex items-center justify-center
                w-10 h-10 rounded-full
                border border-white/20
                text-white
                hover:border-cyan-400
                hover:shadow-lg hover:shadow-cyan-400/20
                transition-all duration-300"
            >
              <Phone className="h-5 w-5 text-cyan-400" />
            </a>

            {/* Phone - Desktop Full */}
            <a
              href="tel:9551776782"
              className="
                hidden md:flex items-center space-x-2
                px-4 lg:px-5 py-2 rounded-full
                border border-white/20
                text-white
                hover:border-cyan-400
                hover:shadow-lg hover:shadow-cyan-400/20
                transition-all duration-300
                hover:-translate-y-0.5"
            >
              <Phone className="h-4 w-4 text-cyan-400" />
              <span className="text-sm font-medium whitespace-nowrap">
                9551776782
              </span>
            </a>

            {/* CTA */}
            <button
              onClick={() => setBookForm(true)}
              className="
                group relative 
                px-4 sm:px-4 md:px-8 
                py-2 sm:py-2.5 md:py-3 
                rounded-full
                bg-gradient-to-r from-rose-500 via-pink-500 to-fuchsia-500
                text-white font-bold md:font-extrabold 
                text-sm sm:text-base tracking-wide
                shadow-xl shadow-pink-500/30
                overflow-hidden
                transition-all duration-300
                hover:shadow-pink-500/50
                hover:-translate-y-0.5
                whitespace-nowrap">

              {/* Light sweep */}
              <span className="
                absolute inset-0 bg-white/25
                translate-x-[-100%] group-hover:translate-x-[100%]
                transition-transform duration-700 skew-x-12">
              </span>

              <span className="relative flex items-center justify-center">
                <span className="hidden xs:inline">BOOK NOW</span>
                <span className="xs:hidden">BOOK</span>
                <ArrowRight className="
                  ml-1 sm:ml-2 h-3 w-3 sm:h-4 sm:w-4
                  transition-transform duration-300
                  group-hover:translate-x-1" />
              </span>
            </button>

          </div>
        </div>
      </div>
    </header>
  )
}

export default Header;